import { getFromServerTopic } from "@utility/slice";
import { talkToServer } from "@helpers/servercomms";
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { logFilter } from "@logging";
import { IDLE, LOADING, SAVING, DELETING } from "@src/constants";
import { IdleTransaction } from "@sentry/tracing";

const SLICE = "equipment";
const tag = "EquipmentSlice";

export const getFromServer = (
  action,
  contextOptionsFn = async ({ arg }) => arg,
  payloadFn = async (arg) => arg,
) => getFromServerTopic({ topic: SLICE, action, contextOptionsFn, payloadFn });

export const getAllEquipmentForStack = getFromServer("getAllEquipmentForStack");
// export const getAllEquipmentForStack = (options) => {
//   logFilter("BuildingStack", "prepping", options);
// };

export const findDefaultCodeForSerials = createAsyncThunk(
  "findDefaultCodeForSerials",
  async (options) => {
    const request = {
      context: {
        topic: "equipment",
        action: "findDefaultCodeForSerials",
        options,
        useCache: false,
      },
    };
    const response = await talkToServer(request);
    if (response && response !== undefined && response.rc === "OK") {
      return {
        response, // pass along what we get back from the server
      };
    }
  },
);

export const getFWVersionsForEquipment = createAsyncThunk(
  "getFWVersionsForEquipment",
  async (options) => {
    const request = {
      context: {
        topic: "equipment",
        action: "getFWVersionsForEquipment",
        options,
        useCache: false,
      },
    };
    const response = await talkToServer(request);
    if (response && response !== undefined && response.rc === "OK") {
      return {
        response, // pass along what we get back from the server
      };
    }
  },
);

export const changeFWVersion = createAsyncThunk(
  "changeFWVersion",
  async (options) => {
    const request = {
      context: {
        topic: "equipment",
        action: "changeFWVersion",
        options,
        useCache: false,
      },
    };
    const response = await talkToServer(request);
    if (response && response !== undefined && response.rc === "OK") {
      return {
        response, // pass along what we get back from the server
      };
    }
  },
);

export const changeFWVersionBulk = createAsyncThunk(
  "changeFWVersionBulk",
  async (options) => {
    const request = {
      context: {
        topic: "equipment",
        action: "changeFWVersionBulk",
        options,
        useCache: false,
      },
    };
    const response = await talkToServer(request);
    if (response && response !== undefined && response.rc === "OK") {
      return {
        response, // pass along what we get back from the server
      };
    }
  },
);

export const getAppCodeVersionsForWBR = createAsyncThunk(
  "getAppCodeVersionsForWBR",
  async (options) => {
    const request = {
      context: {
        topic: "equipment",
        action: "getAppCodeVersionsForWBR",
        options,
        useCache: false,
      },
    };
    const response = await talkToServer(request);
    if (response && response !== undefined && response.rc === "OK") {
      return {
        response, // pass along what we get back from the server
      };
    }
  },
);

export const changeAppCodeVersion = createAsyncThunk(
  "changeAppCodeVersion",
  async (options) => {
    const request = {
      context: {
        topic: "equipment",
        action: "changeAppCodeVersion",
        options,
        useCache: false,
      },
    };
    const response = await talkToServer(request);
    if (response && response !== undefined && response.rc === "OK") {
      return {
        response, // pass along what we get back from the server
      };
    }
  },
);

export const changeBacnetCloud = createAsyncThunk("changeBacnetCloud", async (options) => {
  const request = {
    context: {
      topic: "equipment",
      action: "changeBacnetCloud",
      options,
      useCache: false,
    },
  };
  const response = await talkToServer(request);
  if (response && response !== undefined && response.rc === "OK") {
    return {
      response, // pass along what we get back from the server
    };
  }
});


export const changeFloor = createAsyncThunk("changeFloor", async (options) => {
  const request = {
    context: {
      topic: "equipment",
      action: "changeFloor",
      options,
      useCache: false,
    },
  };
  const response = await talkToServer(request);
  if (response && response !== undefined && response.rc === "OK") {
    return {
      response, // pass along what we get back from the server
    };
  }
});

export const changeAppCodeLock = createAsyncThunk(
  "changeAppCodeLock",
  async (options) => {
    const request = {
      context: {
        topic: "equipment",
        action: "changeAppCodeLock",
        options,
        useCache: false,
      },
    };
    const response = await talkToServer(request);
    if (response && response !== undefined && response.rc === "OK") {
      return {
        response, // pass along what we get back from the server
      };
    }
  },
);
export const changeFirmwareLock = createAsyncThunk(
  "changeFirmwareLock",
  async (options) => {
    const request = {
      context: {
        topic: "equipment",
        action: "changeFirmwareLock",
        options,
        useCache: false,
      },
    };
    const response = await talkToServer(request);
    if (response && response !== undefined && response.rc === "OK") {
      return {
        response, // pass along what we get back from the server
      };
    }
  },
);

export const changeFirmware485Lock = createAsyncThunk(
  "changeFirmware485Lock",
  async (options) => {
    const request = {
      context: {
        topic: "equipment",
        action: "changeFirmware485Lock",
        options,
        useCache: false,
      },
    };
    const response = await talkToServer(request);
    if (response && response !== undefined && response.rc === "OK") {
      return {
        response, // pass along what we get back from the server
      };
    }
  },
);

export const changeCalibrationGroup = createAsyncThunk(
  "changeCalibrationGroup",
  async (options) => {
    const request = {
      context: {
        topic: "equipment",
        action: "changeCalibrationGroup",
        options,
        useCache: false,
      },
    };
    const response = await talkToServer(request);
    if (response && response !== undefined && response.rc === "OK") {
      return {
        response, // pass along what we get back from the server
      };
    }
  },
);

export const resetCO2LowPoint = createAsyncThunk(
  "resetCO2LowPoint",
  async (options) => {
    const request = {
      context: {
        topic: "equipment",
        action: "resetCO2LowPoint",
        options,
        useCache: false,
      },
    };
    const response = await talkToServer(request);
    if (response && response !== undefined && response.rc === "OK") {
      return {
        response, // pass along what we get back from the server
      };
    }
  },
);

export const rebootWellstatEquipment = createAsyncThunk(
  "rebootWellstatEquipment",
  async (options) => {
    const request = {
      context: {
        topic: "equipment",
        action: "rebootWellstatEquipment",
        options,
        useCache: false,
      },
    };
    const response = await talkToServer(request);
    if (response && response !== undefined && response.rc === "OK") {
      return {
        response, // pass along what we get back from the server
      };
    }
  },
);

export const factoryResetWellstatEquipment = createAsyncThunk(
  "factoryResetWellstatEquipment",
  async (options) => {
    const request = {
      context: {
        topic: "equipment",
        action: "factoryResetWellstatEquipment",
        options,
        useCache: false,
      },
    };
    const response = await talkToServer(request);
    if (response && response !== undefined && response.rc === "OK") {
      return {
        response, // pass along what we get back from the server
      };
    }
  },
);

export const changeRF = createAsyncThunk("changeRF", async (options) => {
  const request = {
    context: {
      topic: "equipment",
      action: "changeRF",
      options,
      useCache: false,
    },
  };
  const response = await talkToServer(request);
  if (response && response !== undefined && response.rc === "OK") {
    return {
      response, // pass along what we get back from the server
    };
  }
});

export const changeTimeslot = createAsyncThunk(
  "changeTimeslot",
  async (options) => {
    const request = {
      context: {
        topic: "equipment",
        action: "changeTimeslot",
        options,
        useCache: false,
      },
    };
    const response = await talkToServer(request);
    if (response && response !== undefined && response.rc === "OK") {
      return {
        response, // pass along what we get back from the server
      };
    }
  },
);

export const overrideHWID = createAsyncThunk(
  "overrideHWID",
  async (options) => {
    const request = {
      context: {
        topic: "equipment",
        action: "overrideHWID",
        options,
        useCache: false,
      },
    };
    const response = await talkToServer(request);
    if (response && response !== undefined && response.rc === "OK") {
      return {
        response, // pass along what we get back from the server
      };
    }
  },
);

export const changeInstallCategory = createAsyncThunk(
  "changeInstallCategory",
  async (options) => {
    const request = {
      context: {
        topic: "equipment",
        action: "changeInstallCategory",
        options,
        useCache: false,
      },
    };
    const response = await talkToServer(request);
    if (response && response !== undefined && response.rc === "OK") {
      return {
        response, // pass along what we get back from the server
      };
    }
  },
);

export const changeSpace = createAsyncThunk("changeSpace", async (options) => {
  const request = {
    context: {
      topic: "equipment",
      action: "changeSpace",
      options,
      useCache: false,
    },
  };
  const response = await talkToServer(request);
  if (response && response !== undefined && response.rc === "OK") {
    return {
      response, // pass along what we get back from the server
    };
  }
});

export const uninstallDevice = createAsyncThunk(
  "uninstallDevice",
  async (options) => {
    const request = {
      context: {
        topic: "equipment",
        action: "uninstallDevice",
        options,
        useCache: false,
      },
    };
    const response = await talkToServer(request);
    if (response && response !== undefined && response.rc === "OK") {
      return {
        response, // pass along what we get back from the server
      };
    }
  },
);

export const replaceDevice = createAsyncThunk(
  "replaceDevice",
  async (options) => {
    const request = {
      context: {
        topic: "equipment",
        action: "replaceDevice",
        options,
        useCache: false,
      },
    };
    const response = await talkToServer(request);
    if (response && response !== undefined && response.rc === "OK") {
      return {
        response, // pass along what we get back from the server
      };
    }
  },
);

export const isDeviceEligible = createAsyncThunk(
  "isDeviceEligible",
  async (options) => {
    const request = {
      context: {
        topic: "equipment",
        action: "isDeviceEligible",
        options,
        useCache: false,
      },
    };
    const response = await talkToServer(request);
    if (response && response !== undefined && response.rc === "OK") {
      return {
        response, // pass along what we get back from the server
      };
    }
  },
);

export const patchSensors = createAsyncThunk(
  "patchSensors",
  async (options) => {
    const request = {
      context: {
        topic: "equipment",
        action: "patchSensors",
        options,
        useCache: false,
      },
    };
    const response = await talkToServer(request);
    if (response && response !== undefined && response.rc === "OK") {
      return {
        response, // pass along what we get back from the server
      };
    }
  },
);

export const assignEquipmentToSite = createAsyncThunk(
  "assignEquipmentToSite",
  async (options) => {
    const request = {
      context: {
        topic: "equipment",
        action: "assignEquipmentToSite",
        options,
        useCache: false,
      },
    };
    const response = await talkToServer(request);
    if (response && response !== undefined && response.rc === "OK") {
      return {
        response, // pass along what we get back from the server
      };
    }
  },
);

export const cancelOTACommand = createAsyncThunk(
  "cancelOTACommand",
  async (options) => {
    const request = {
      context: {
        topic: "equipment",
        action: "cancelOTAQueueItem",
        options,
        useCache: false,
      },
    };
    const response = await talkToServer(request);
    if (response && response !== undefined && response.rc === "OK") {
      return {
        response, // pass along what we get back from the server
      };
    }
  },
);

export const addEquipmentToSite = getFromServer("addEquipmentToSite");

export const createEquipmentFromAnother = getFromServer(
  "createEquipmentFromAnother",
  async ({ arg: { importAliasToSensorTypeId, ...rest } }) => ({
    ...rest,
  }),
);

export const confirmEquipmentAliasesExist = getFromServer(
  "confirmImportAliasesExist",
);

export const deleteEquipmentById = getFromServer("deleteEquipmentById");

export const addEquipmentSensor = getFromServer("addEquipmentSensor");

export const removeEquipmentSensor = getFromServer("removeEquipmentSensor");

export const slice = createSlice({
  name: SLICE,
  initialState: {
    status: IDLE,
    uninstallStatus: IDLE,
    replaceStatus: IDLE,
    replaceValidation: [],
    okToReplace: false,
    eligibleStatus: IDLE,
    patchSensorStatus: IDLE,
    assignEquipmentStatus: IDLE,
    changeFloorStatus: IDLE,
    changeBacnetCloudStatus: IDLE,
    changeAppCodeVersionStatus: IDLE,
    changeFWVersionStatus: IDLE,
    changeFirmwareLockStatus: IDLE,
    changeCalibrationGroupStatus: IDLE,
    changeRFStatus: IDLE,
    changeTimeslotStatus: IDLE,
    overrideHWIDStatus: IDLE,
    resetCO2LowPointStatus: IDLE,
    rebootWellstatEquipmentStatus: IDLE,
    factoryResetWellstatEquipmentStatus: IDLE,
    changeSpaceStatus: IDLE,
    changeInstallCategoryStatus: IDLE,
    defaultCodeForSerials: {},
    FWVersions: {},
    stackData: {
      // 3076: {
      //   wbrs: [],
      // },
    },
  },
  reducers: {
    resetOKToReplace: (state) => {
      state.okToReplace = false;
      state.replaceValidation = [];
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getAllEquipmentForStack.fulfilled, (state, action) => {
        logFilter("builder", state);
        logFilter("builder", action);
        if (action.payload.response.context) {
          const site_id = action.payload.response.context.options.site_id;
          state.stackData[site_id] = action.payload.response.payload.stackData;
        }
      })
      .addCase(getFWVersionsForEquipment.fulfilled, (state, action) => {
        if (
          action.payload.response.context &&
          action.payload.response.rc === "OK"
        ) {
          state.FWVersions[`${action.payload.response.context.options.equipment_template_id}${action.payload.response.context.options.is485}${action.payload.response.context.options.hardwareid}`] = action.payload.response.payload.FWVersions;
        }
      })
      .addCase(findDefaultCodeForSerials.fulfilled, (state, action) => {
        if (
          action.payload.response.context &&
          action.payload.response.rc === "OK"
        ) {
          action.payload.response.payload.defaultCodeForSerials.map(
            (d) => (state.defaultCodeForSerials[d.name] = d),
          );
        }
      })
      .addCase(changeFWVersion.pending, (state) => {
        state.changeFWVersionStatus = SAVING;
      })
      .addCase(changeFWVersion.fulfilled, (state) => {
        state.changeFWVersionStatus = IDLE;
      })
      .addCase(getAppCodeVersionsForWBR.fulfilled, (state, action) => {
        if (
          action.payload.response.context &&
          action.payload.response.rc === "OK"
        ) {
          state.appCodeVersions =
            action.payload.response.payload.appCodeVersions;
        }
      })
      .addCase(changeAppCodeVersion.pending, (state) => {
        state.changeAppCodeVersionStatus = SAVING;
      })
      .addCase(changeAppCodeVersion.fulfilled, (state) => {
        state.changeAppCodeVersionStatus = IDLE;
      })
      .addCase(changeFloor.pending, (state) => {
        state.changeFloorStatus = SAVING;
      })
      .addCase(changeFloor.fulfilled, (state) => {
        state.changeFloorStatus = IDLE;
      })
      .addCase(changeBacnetCloud.pending, (state) => {
        state.changeBacnetCloudStatus = SAVING;
      })
      .addCase(changeBacnetCloud.fulfilled, (state) => {
        state.changeBacnetCloudStatus = IDLE;
      })
      .addCase(changeAppCodeLock.pending, (state) => {
        state.changeFirmwareLockStatus = SAVING;
      })
      .addCase(changeAppCodeLock.fulfilled, (state) => {
        state.changeFirmwareLockStatus = IDLE;
      })
      .addCase(changeFirmwareLock.pending, (state) => {
        state.changeFirmwareLockStatus = SAVING;
      })
      .addCase(changeFirmwareLock.fulfilled, (state) => {
        state.changeFirmwareLockStatus = IDLE;
      })
      .addCase(changeFirmware485Lock.pending, (state) => {
        state.changeFirmwareLockStatus = SAVING;
      })
      .addCase(changeFirmware485Lock.fulfilled, (state) => {
        state.changeFirmwareLockStatus = IDLE;
      })
      .addCase(changeCalibrationGroup.pending, (state) => {
        state.changeCalibrationGroupStatus = SAVING;
      })
      .addCase(changeCalibrationGroup.fulfilled, (state) => {
        state.changeCalibrationGroupStatus = IDLE;
      })
      .addCase(overrideHWID.pending, (state) => {
        state.overrideHWIDStatus = SAVING;
      })
      .addCase(overrideHWID.fulfilled, (state) => {
        state.overrideHWIDStatus = IDLE;
      })
      .addCase(changeRF.pending, (state) => {
        state.changeRFStatus = SAVING;
      })
      .addCase(changeRF.fulfilled, (state) => {
        state.changeRFStatus = IDLE;
      })
      .addCase(changeTimeslot.pending, (state) => {
        state.changeTimeslotStatus = SAVING;
      })
      .addCase(changeTimeslot.fulfilled, (state) => {
        state.changeTimeslotStatus = IDLE;
      })
      .addCase(factoryResetWellstatEquipment.pending, (state) => {
        state.factoryResetWellstatEquipmentStatus = SAVING;
      })
      .addCase(factoryResetWellstatEquipment.fulfilled, (state) => {
        state.factoryResetWellstatEquipmentStatus = IDLE;
      })
      .addCase(rebootWellstatEquipment.pending, (state) => {
        state.rebootWellstatEquipmentStatus = SAVING;
      })
      .addCase(rebootWellstatEquipment.fulfilled, (state) => {
        state.rebootWellstatEquipmentStatus = IDLE;
      })
      .addCase(resetCO2LowPoint.pending, (state) => {
        state.resetCO2LowPointStatus = SAVING;
      })
      .addCase(resetCO2LowPoint.fulfilled, (state) => {
        state.resetCO2LowPointStatus = IDLE;
      })
      .addCase(changeInstallCategory.pending, (state) => {
        state.changeInstallCategoryStatus = SAVING;
      })
      .addCase(changeInstallCategory.fulfilled, (state) => {
        state.changeInstallCategoryStatus = IDLE;
      })
      .addCase(changeSpace.pending, (state) => {
        state.changeSpaceStatus = SAVING;
      })
      .addCase(changeSpace.fulfilled, (state) => {
        state.changeSpaceStatus = IDLE;
      })
      .addCase(uninstallDevice.pending, (state) => {
        state.uninstallStatus = DELETING;
      })
      .addCase(uninstallDevice.fulfilled, (state) => {
        state.uninstallStatus = IDLE;
      })
      .addCase(replaceDevice.pending, (state) => {
        state.replaceStatus = SAVING;
      })
      .addCase(replaceDevice.fulfilled, (state, action) => {
        state.replaceStatus = IDLE;
        state.replaceValidation = action.payload.response.payload.validation;
      })
      .addCase(isDeviceEligible.pending, (state) => {
        state.eligibleStatus = LOADING;
      })
      .addCase(isDeviceEligible.fulfilled, (state) => {
        state.eligibleStatus = IDLE;
      })
      .addCase(patchSensors.pending, (state) => {
        state.patchSensorStatus = SAVING;
      })
      .addCase(patchSensors.fulfilled, (state) => {
        state.patchSensorStatus = IDLE;
      })
      .addCase(assignEquipmentToSite.pending, (state) => {
        state.assignEquipmentStatus = SAVING;
      })
      .addCase(assignEquipmentToSite.fulfilled, (state) => {
        state.assignEquipmentStatus = IDLE;
      })
      .addCase(cancelOTACommand.pending, (state) => {
        state.status = SAVING;
      })
      .addCase(cancelOTACommand.fulfilled, (state, action) => {
        logFilter(tag, state);
        logFilter(tag, action);
        state.status = IDLE;
      });
  },
});

export const { resetOKToReplace } = slice.actions;
export default slice.reducer;
